import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoMinified = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M34.9984 39.9966C37.7609 39.9966 40.0003 37.7585 40.0003 34.9977C40.0003 32.2369 37.7609 29.9988 34.9984 29.9988C32.236 29.9988 29.9966 32.2369 29.9966 34.9977C29.9966 37.7585 32.236 39.9966 34.9984 39.9966Z",
			fill: "#00F0FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M34.9977 0.00296501H5.00137C2.23937 0.00296501 -0.000488281 2.24149 -0.000488281 5.00185C-0.000488281 7.76221 2.23937 10.0007 5.00137 10.0007H22.9232L1.46506 31.4669C0.0351121 32.896 -0.392092 35.0485 0.382216 36.9135C1.15652 38.7814 2.98104 40 5.00433 40H23.9912C26.7532 40 28.9931 37.7615 28.9931 35.0011C28.9931 32.2408 26.7532 30.0022 23.9912 30.0022H17.0729L38.534 8.53606C39.9639 7.10696 40.3911 4.95441 39.6168 3.0865C38.8425 1.21859 37.018 0 34.9947 0L34.9977 0.00296501Z",
			fill: "white"
		})
	]
});
const ForwardRef = forwardRef(SvgLogoMinified);
export default ForwardRef;
